import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Divider, Form } from 'antd';

import { useCreateBankAccount } from '@/core/domain/enterprise/BankAccounts/BankAccounts.hooks';
import { CreateBankAccountFormValues } from '@/core/domain/enterprise/BankAccounts/BankAccounts.types';

import { PageProps } from '@/types/PageProps';

import BankAccountForm from '@/components/Registry/BankAccounts/BankAccountForm';

import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { SaveButton } from '@/components/_common/Buttons';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';

function BankAccountsCreatePage({ route }: PageProps) {
  const history = useHistory();

  const [form] = Form.useForm<CreateBankAccountFormValues>();

  const mutation = useCreateBankAccount();

  const handleSaveClick = async () => {
    try {
      const { bank, ...values } = await form.validateFields();

      const obj = {
        ...values,
        bankId: bank.id,
        active: true,
      };

      const response = await mutation.mutateAsync(obj);

      history.push(`/app/financial/accounts/bankAccounts/${response.id}`);
    } catch {}
  };

  return (
    <TabContentWrapper
      permissions={route.permissions}
      title={route.name}
      extra={
        <SaveButton
          block
          type="primary"
          onClick={handleSaveClick}
          loading={mutation.isLoading}
          disabled={!hasPermissions([Authorities.REGISTER_BANK_ACCOUNT_ADD])}
        >
          <FormattedMessage id="commons.form.button.save" />
        </SaveButton>
      }
    >
      <BankAccountForm form={form} />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/financial/accounts/bankAccounts" />
      </SpaceForButton>
    </TabContentWrapper>
  );
}

export default BankAccountsCreatePage;
